// Global chat drawer utility functions
// These functions can be called from anywhere in the app to open the chat drawer

declare global {
  interface Window {
    openChatWithUser?: (userId: string, userEmail: string) => void;
    openChatWithChatId?: (
      chatId: string,
      senderId: string,
      senderEmail: string
    ) => void;
  }
}

// Function to open chat drawer with a specific user
export const openChatWithUser = (userId: string, userEmail: string) => {
  if (window.openChatWithUser) {
    window.openChatWithUser(userId, userEmail);
  } else {
    console.warn(
      "Chat drawer not available. Make sure ChatDrawerProvider is mounted."
    );
  }
};

// Function to open chat drawer with a specific chat ID
export const openChatWithChatId = (
  chatId: string,
  senderId: string,
  senderEmail: string
) => {
  if (window.openChatWithChatId) {
    window.openChatWithChatId(chatId, senderId, senderEmail);
  } else {
    console.warn(
      "Chat drawer not available. Make sure ChatDrawerProvider is mounted."
    );
  }
};

// Function to set the global chat drawer functions
export const setGlobalChatDrawer = (
  openChatWithUserFn: (userId: string, userEmail: string) => void,
  openChatWithChatIdFn: (
    chatId: string,
    senderId: string,
    senderEmail: string
  ) => void
) => {
  window.openChatWithUser = openChatWithUserFn;
  window.openChatWithChatId = openChatWithChatIdFn;
};
